import { Header } from "./Header";
import HeaderMenu from "./HeaderMenu";
import { useLocation } from "react-router-dom";

const HeaderWithMenu = () => {
  const location = useLocation();
  if (location.pathname.includes("preview")) {
    return null;
  }
  return (
    <Header>
      <HeaderMenu />
    </Header>
  );
};

export default HeaderWithMenu;
